import { useState } from 'react';
import axiosInstance from '../../../axiosInstance';
import Swal from 'sweetalert2';

export default function useSftpDownload() {
    const [docLoading, setDocLoading] = useState(null);

    /**
     * Download file from SFTP.
     * @param {string} sftpPath - Windows path like E:\DocumentVault\...
     * @param {string|number} docId - ID for loading state
     * @param {'blob'|'preview'|'download'} mode
     *   - 'blob': returns Blob (for PdfPreviewModal)
     *   - 'preview': opens in new tab (fallback)
     *   - 'download': triggers file download
     * @returns {Blob|null} - Blob if mode='blob', null otherwise
     */
    const handleDownload = async (sftpPath, docId, mode = 'download') => {
        if (!sftpPath) return null;
        setDocLoading(docId);
        try {
            const response = await axiosInstance.post('/tool-doc/download', { docLocation: sftpPath }, { responseType: 'blob' });
            const blob = response.data;
            const fileName = sftpPath.split(/[/\\]/).pop() || 'document';

            if (mode === 'blob') {
                return blob;
            }

            const url = window.URL.createObjectURL(blob);
            if (mode === 'preview') {
                window.open(url, '_blank');
            } else {
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            setTimeout(() => window.URL.revokeObjectURL(url), 5000);
            return null;
        } catch (error) {
            console.error('Error downloading doc:', error);
            Swal.fire({ icon: 'error', title: 'Error', text: error.response?.status === 404 ? 'File not found on server' : 'Failed to download file' });
            return null;
        } finally {
            setDocLoading(null);
        }
    };

    return { docLoading, handleDownload };
}
